import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bc727f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reason-selection-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "사유 선택", -1 /* HOISTED */))
const _hoisted_3 = {
  class: "btns-wrapper",
  role: "radiogroup",
  "aria-label": "신고 사유 선택"
}
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reportReasons, (reason) => {
        return (_openBlock(), _createBlock($setup["ReportReasonButton"], {
          key: reason.code,
          class: "btn",
          type: "button",
          selected: reason.code === $setup.selectedReason?.code,
          reason: reason,
          onClick: ($event: any) => ($setup.updateSelectedReason(reason))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(reason.name), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "reason", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("footer", _hoisted_4, [
      _createVNode($setup["BaseButton"], {
        title: "신고하기",
        disabled: !$setup.selectedReason,
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowReportGuideModal(true)))
      }, null, 8 /* PROPS */, ["disabled"])
    ]),
    _createCommentVNode(" 신고 절차 안내 모달 "),
    ($setup.shouldShowReportGuideModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          modalClass: "report-guide-modal",
          title: "신고하시겠습니까?",
          okButtonTitle: "신고하기",
          cancelButtonTitle: "취소",
          onOnClickOkButton: _cache[1] || (_cache[1] = ($event: any) => ([$setup.toggleShowReportGuideModal(false), $setup.requestReport()])),
          onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowReportGuideModal(false)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: "modal-content",
              innerHTML: $setup.reportGuideContent
            }, null, 8 /* PROPS */, _hoisted_5)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}